<header class="navigation">
  <div class="buttons">
    @if (isReservationLocationChangeActive$ | async) {
      @if (!(isReservationLocationChangeReturning$ | async)) {
        <button
          class="header-back-button"
          type="button"
          [attr.aria-label]="translation.wayfinding.goBack | transloco"
          (click)="navigateBackToReservationOverview()"
        >
          <cue-icon [icon]="ICONS.cueArrowLeft"></cue-icon>
        </button>
      }
    }

    @if ((currentOutlookReservationMode$ | async) === outlookReservationMode.Edit) {
      <button class="small" (click)="navigateToReservationList()">
        {{ translation.outlookAddin.changeLocation | transloco }}
      </button>
    }
  </div>
  <div (click)="mobileHamburger = !mobileHamburger" class="hamburger">
    @if (mobileHamburger) {
      <cue-icon [icon]="ICONS.cueClose"></cue-icon>
    }
    @if (!mobileHamburger) {
      <cue-icon [icon]="ICONS.cueUser"></cue-icon>
    }
  </div>
</header>

<div class="menu-nav" [class.opened]="mobileHamburger">
  <div class="menu-wrapper">
    <div class="profile-header">
      <h1 class="profile-title">{{ translation.profile.headingProfile | transloco }}</h1>
    </div>

    @if (!isUserLoggedIn()) {
      <div class="menu-item" (click)="loginWithMsDialog()">
        {{ translation.outlookAddin.login | transloco }}
      </div>
    }
    @if (isUserLoggedIn()) {
      @if (userInfo$ | async; as userInfo) {
        @if (!userInfo.loading && userInfo.data) {
          <div class="user-info">
            {{ userInfo.data.name }} <span class="email">({{ userInfo.data.email }})</span>
          </div>
        }
        <!--                <div class="menu-item" (click)="logout()">-->
        <!--                    {{ translation.outlookAddin.logout | transloco }}-->
        <!--                </div>-->
      }
    }

    <div class="data-item language-label">
      <div class="language-wrapper">
        <assist-dropdownlist
          [data]="languageItems"
          [formControl]="currentLanguageControl"
          [popupSettings]="{
            popupClass: 'language-popup',
            width: 'auto',
          }"
          textField="text"
          valueField="text"
        >
          <ng-template let-dataItem valueTemplate>
            <img
              [src]="'assets/images/flags/' + dataItem?.flag"
              alt="language-flag"
              class="flag"
              height="30"
              width="30"
            />
          </ng-template>
          <ng-template itemTemplate let-dataItem>
            <img
              [src]="'assets/images/flags/' + dataItem.flag"
              alt="language-flag"
              class="flag"
              height="30"
              width="30"
            />
            <span class="lang-shortcut">{{ dataItem.text }}</span>
          </ng-template>
        </assist-dropdownlist>
      </div>
    </div>
    @if (version.hasValue()) {
      <div>{{ translation.login.version | transloco }}: {{ version.value() }}, {{ instalationName }}</div>
    }
  </div>
</div>
